export var isObject = function isObject(value) {
  return typeof value === 'object' && value !== null
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-files/lib/isObject.mjs
// module id = 270
// module chunks = 0